class CommentFormController {
  constructor(element) {
    this.element = element
    this.textarea = element.querySelector('textarea')
    this.form = element.closest('form')
    this.bindEvents()
  }

  bindEvents() {
    this.textarea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        if (!e.shiftKey) {
          e.preventDefault()
          this.form.requestSubmit()
        }
      }
    })

    this.form.addEventListener('submit', (e) => {
      e.preventDefault()
      this.submitAjax()
    })
  }

  submitAjax() {
    const body = (this.textarea.value || '').trim()
    if (!body) return

    const url = this.form.getAttribute('action')
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const submitBtn = this.form.querySelector('input[type="submit"], button[type="submit"]')
    if (submitBtn) submitBtn.disabled = true

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrf
      },
      body: JSON.stringify({ version_comment: { body } })
    }).then(async (res) => {
      if (!res.ok) {
        const text = await res.text()
        throw new Error(text)
      }
      return res.json()
    }).then((data) => {
      if (data && data.success && data.html) {
        this.prependCommentHtml(data.html)
        this.textarea.value = ''
      }
    }).catch((err) => {
      console.error('Comment save error:', err)
      alert('Opslaan van opmerking mislukt')
    }).finally(() => {
      if (submitBtn) submitBtn.disabled = false
    })
  }

  prependCommentHtml(html) {
    const commentsList = this.form.closest('.version-comments')?.querySelector('.comments-list')
    if (!commentsList) return
    const wrapper = document.createElement('div')
    wrapper.innerHTML = html
    const node = wrapper.firstElementChild
    if (node) commentsList.prepend(node)
  }

  escapeHtml(str) {
    const div = document.createElement('div')
    div.textContent = String(str)
    return div.innerHTML.replace(/\n/g, '<br>')
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.comment-input-group').forEach(element => {
    new CommentFormController(element)
  })
}) 

// One-time global handler to delete comments via AJAX without reload
if (!window.__commentDeleteAjaxBound) {
  window.__commentDeleteAjaxBound = true
  document.addEventListener('submit', (e) => {
    const form = e.target
    if (!(form instanceof HTMLFormElement)) return
    // Match delete forms inside comments
    const inComments = form.closest('.version-comments')
    const isDelete = form.querySelector('input[name="_method"][value="delete"]')
    if (!inComments || !isDelete) return

    e.preventDefault()
    // Single confirm point
    const confirmMsg = 'Weet je zeker dat je deze opmerking wilt verwijderen?'
    if (!window.confirm(confirmMsg)) return

    const url = form.getAttribute('action')
    const csrf = document.querySelector('meta[name="csrf-token"]').content
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]')
    if (submitBtn) submitBtn.disabled = true

    fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': csrf
      }
    }).then((res) => {
      if (!res.ok && res.status !== 204) throw new Error('Delete failed')
      const commentEl = form.closest('.comment')
      if (commentEl) commentEl.remove()
    }).catch((err) => {
      console.error('Delete comment error:', err)
      alert('Verwijderen mislukt')
    }).finally(() => {
      if (submitBtn) submitBtn.disabled = false
    })
  })
}